import type { MayBe } from 'types/common';

import { createDictionary } from './utils';

export const calculateWithVAT = (price: MayBe<number>, vat: number | null): MayBe<number> =>
  (vat ? roundNumber(Number(price) * (1 + vat / 100)) : price);

export const roundNumber = (value: number, decimal = 2): number => {
  const pow = 10 ** decimal;
  return Math.round(value * pow) / pow;
};

/**
 * Rounds the value to the 'nearest' 0.05, as per Swiss regulations.
 * Example: 1.22 => 1.20, 1.23 => 1.25, 1.27 => 1.25, 1.28 => 1.30
 */
const roundingForSwitzerland = (value: number): number => Math.round(value * 20) / 20;

export const roundAmountByCountry = createDictionary(
  {
    CH: roundingForSwitzerland,
    LI: roundingForSwitzerland, // Liechtenstein uses the Swiss franc
  },
  roundNumber
);
